module.exports = __webpack_public_path__ + "static/media/gears.3de1f126.svg";